import { createContext, useContext } from "react";
import { Lab, Membership, Unit, User } from "../../../backend/src/types";

export interface sessionUser {
  user: User | null;
  setUser: (user: User | null) => void;
  memberships: Membership[];
  setMemberships: (memberships: Membership[]) => void;
  units: Unit[];
  setUnits: (units: Unit[]) => void;
  labs: Lab[];
  setLabs: (labs: Lab[]) => void;
  userLabs: Lab[];
  setUserLabs: (labs: Lab[]) => void;
  isLoading: boolean;
  alertCount: number;
  setAlertCount: (alertCount: number) => void;
}

export const userContext = createContext<sessionUser | null>(null);

export const useUser = () => {
  const context = useContext(userContext);
  if (!context) throw new Error("useUser must be used within UserProvider");
  return context;
};
